import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "centered-vert flex-align-right" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Delete Users ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Rehire Users ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Export Users ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Bulk User Operations ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document el-icon-right" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Rehire")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBar = _resolveComponent("SearchBar")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_container = _resolveComponent("el-container")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_UserBulkDiag = _resolveComponent("UserBulkDiag")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_el_container, {
      direction: "horizontal",
      class: "margin-vert"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { width: "300px" }, {
          default: _withCtx(() => [
            _createVNode(_component_SearchBar, {
              useSearch: true,
              useStatusUsers: true,
              useUserGroups: true,
              onSearchChange: _ctx.atSearchChange,
              onStatusChange: _ctx.atStatusChange,
              onUserGroupsChange: _ctx.atUserGroupsChange
            }, null, 8, ["onSearchChange", "onStatusChange", "onUserGroupsChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { direction: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, { direction: "horizontal" }, {
              default: _withCtx(() => [
                _createVNode("h4", null, "Displaying " + _toDisplayString(_ctx.returnCount) + " out of " + _toDisplayString(_ctx.total) + " results", 1),
                _createVNode("span", _hoisted_1, [
                  (_ctx.selectedUsers.length)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deactivateUsers(_ctx.selectedUsers)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.selectedUsers.length)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reactivateUsers(_ctx.selectedUsers)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportUsersAndDownload()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.bulkDialogueVisible = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              stripe: "",
              data: _ctx.users,
              onSortChange: _ctx.onSortChanged,
              onSelectionChange: _ctx.selectionChangeHandler,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "selection" }),
                _createVNode(_component_el_table_column, {
                  prop: "first_name",
                  sortable: "custom",
                  label: "First Name"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "last_name",
                  sortable: "custom",
                  label: "Last Name"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "user_id",
                  sortable: "custom",
                  label: "User ID"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "last_visit",
                  sortable: "custom",
                  label: "Last Visit"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.convertDateString(scope.row.last_visit, _ctx.userPrefs?.timezone)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "created",
                  sortable: "custom",
                  label: "Created"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.convertDateString(scope.row.created, _ctx.userPrefs?.timezone)), 1)
                  ]),
                  _: 1
                }),
                (_ctx.isVAR || _ctx.isSuperAdmin)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      prop: "organization_name",
                      label: "Organization"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, { label: "Groups" }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(row.groups.join(', ')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Options" }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_link, {
                      class: "el-button el-button--mini is-circle",
                      size: "mini",
                      href: `/#/users/edit/${row.id}`,
                      icon: "el-icon-edit-outline",
                      underline: false,
                      circle: "",
                      plain: ""
                    }, null, 8, ["href"]),
                    (row.groups.includes('deleted'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          size: "mini",
                          type: "success",
                          round: "",
                          plain: "",
                          onClick: ($event: any) => (_ctx.reactivateUser(row.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          size: "mini",
                          type: "danger",
                          icon: "el-icon-delete",
                          plain: "",
                          circle: "",
                          onClick: ($event: any) => (_ctx.deactivateUser(row.id))
                        }, null, 8, ["onClick"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "onSortChange", "onSelectionChange"]),
            _createVNode(_component_el_pagination, {
              class: "margin-auto margin-vert",
              background: "",
              layout: "sizes, prev, pager, next",
              "page-sizes": [10, 20, 50, 100, 200],
              total: _ctx.total,
              "page-size": _ctx.pageSize,
              "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_ctx.pageSize = $event)),
              "current-page": _ctx.page,
              "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => (_ctx.page = $event))
            }, null, 8, ["total", "page-size", "current-page"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
    ]),
    _createVNode(_component_UserBulkDiag, {
      onDialogClosing: _cache[7] || (_cache[7] = ($event: any) => (_ctx.bulkDialogueVisible = false)),
      isVisible: _ctx.bulkDialogueVisible,
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.bulkDialogueVisible = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}